import { render } from "./OpticalExperiment.vue?vue&type=template&id=6e85e74b&scoped=true"
import script from "./OpticalExperiment.vue?vue&type=script&lang=js"
export * from "./OpticalExperiment.vue?vue&type=script&lang=js"

import "./OpticalExperiment.vue?vue&type=style&index=0&id=6e85e74b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e85e74b"]])

export default __exports__